import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toastSuccess, toastError } from "../../common/Toast";
import * as Yup from "yup";
import { Field, Form, Formik, useFormik } from "formik";
import Select from "react-select";
import { uploadAWS } from "../../common/AWSHelper";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  AWS_IMAGE_FOLDER,
  AWS_IMAGE_FOLDER_CATEGORIES,
} from "../../common/Constant";

const EditProfileModal = (props) => {
  const [formValues, setFormValues] = useState({
    // ID: 0,
    OldPassword: "",
    NewPassword: "",
    ConfirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [selectedParentCategory, setselectedParentCategory] = useState(0);
  const [data, setData] = useState([]);
  const Id = localStorage.getItem("ID");
  const paramObject = useParams();
  const [btnLoader, setBtnLoader] = useState({ Imagename: false });
  const [ImageUrl, setImageUrl] = useState("");
  const [eye, seteye] = useState(true);
  const [eyeNew, seteyeNew] = useState(true);
  const [eyeConfirm, setConfirmeye] = useState(true);
  let navigate = useNavigate();

  const onEyeClick = () => {
    seteye(!eye);
  };
  const onEyeNewClick = () => {
    seteyeNew(!eyeNew);
  };
  const onEyeConfirmClick = () => {
    setConfirmeye(!eyeConfirm);
  };

  let ParentCategoryOption = [];
  const ItemKits = data.map((u, i) => {
    ParentCategoryOption[i] = { label: u.Name, value: u.ID };
  });

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      position: "absolute",
      background: "#f8f8f8",
      width: "100%",
      zIndex: 99,
    }), // dropdown menu css
  };

  const schema = Yup.object().shape({
    OldPassword: Yup.string()
      .required("Old Password is required")
      .min(6, "Password must be at least 6 characters")
      .max(20, "Password must not exceed 20 characters"),
    NewPassword: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters")
      .max(20, "Password must not exceed 20 characters"),
    ConfirmPassword: Yup.string()
      .required("Password is mandatory")
      .oneOf([Yup.ref("NewPassword")], "Passwords does not match"),
  });

  const handleSubmit = (values) => {
    setLoading(true);

    let passwordUpdate = {
      id: Id,
      oldpassword: values.OldPassword,
      newpassword: values.NewPassword,
    };
    console.log("passwordUpdate", passwordUpdate);

    axios
      .post(
        `${config.employeesBaseUrl}/employees/updatepassword`,
        passwordUpdate,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseCode);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseMessage);
          setLoading(false);
          window.location.reload();
          navigate("/edit-profile");
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(res.data.ResponseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  return (
    <>
      {/* Upset Model  */}
      <div
        className="modal fade"
        id="MyProfile"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Password</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <Formik
                // {...props}
                initialValues={formValues}
                validationSchema={schema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group row">
                          <label className="col-form-label col-md-3">
                            Old Password <span className="text-danger">*</span>
                          </label>
                          <div className="pass-group col-md-9">
                            <Field
                              type={eye ? "password" : "text"}
                              name="OldPassword"
                              className={` ${
                                errors.OldPassword ? "is-invalid" : ""
                              }`}
                              placeholder="Enter Old Password"
                              // value={values.Name}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                            <span
                              onClick={onEyeClick}
                              className={`fas toggle-password ${
                                eye ? "fa-eye-slash" : "fa-eye"
                              } `}
                            />
                            <div className="invalid-feedback">
                              {touched.OldPassword && errors.OldPassword
                                ? errors.OldPassword
                                : ""}
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-form-label col-md-3">
                            New Password<span className="text-danger">*</span>
                          </label>
                          <div className="pass-group col-md-9">
                            <Field
                              type={eyeNew ? "password" : "text"}
                              name="NewPassword"
                              className={` ${
                                errors.NewPassword ? "is-invalid" : ""
                              }`}
                              placeholder="Enter New Password"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                            <span
                              onClick={onEyeNewClick}
                              className={`fas toggle-password ${
                                eyeNew ? "fa-eye-slash" : "fa-eye"
                              } `}
                            />
                            <div className="invalid-feedback">
                              {touched.NewPassword && errors.NewPassword
                                ? errors.NewPassword
                                : ""}
                            </div>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-form-label col-md-3">
                            Confirm Password
                            <span className="text-danger">*</span>
                          </label>
                          <div className="pass-group col-md-9">
                            <Field
                              type={eyeConfirm ? "password" : "text"}
                              name="ConfirmPassword"
                              id="ConfirmPassword"
                              className={` ${
                                errors.ConfirmPassword ? "is-invalid" : ""
                              }`}
                              placeholder="Enter Confirm Password"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                            <span
                              onClick={onEyeConfirmClick}
                              className={`fas toggle-password ${
                                eyeConfirm ? "fa-eye-slash" : "fa-eye"
                              } `}
                            />
                            <div className="invalid-feedback">
                              {touched.ConfirmPassword && errors.ConfirmPassword
                                ? errors.ConfirmPassword
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 justify-content-right">
                        <button
                          type="submit"
                          className="btn btn-primary btn-md me-1"
                          // onClick={handleSubmit}
                        >
                          Submit
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProfileModal;
